import Vue from 'vue';
const loadGoogleMapsApi = require('load-google-maps-api-2')

Vue.prototype.$loadGoogleMapsApi = loadGoogleMapsApi
